export function handleRemoveObservationWorkflowClick(e) {
    const $currentTarget = $(e.currentTarget);

    sendRemoveUnRemoveRequest($currentTarget, 'remove_workflow_item');

    return false;
}

export function handleUnRemoveObservationWorkflowClick(e) {
    const $currentTarget = $(e.currentTarget);

    sendRemoveUnRemoveRequest($currentTarget, 'unremove_workflow_item');

    return false;
}

function sendRemoveUnRemoveRequest($currentTarget, actionType) {
    const $panel = $currentTarget.parents("td").find(".workflow-status-panel");

    const $parentForm = $currentTarget.parent();
    const $parentSiblingForm = $currentTarget.parent().siblings('form');

    const url = $parentForm.attr("action");
    const valuePairs = $parentForm.serializeArray();

    if (actionType === 'remove_workflow_item') {
        valuePairs.push({name: "remove_workflow_item", value: "TRUE"});
    } else {
        valuePairs.push({name: "unremove_workflow_item", value: "TRUE"});
    }

    $.post(url, valuePairs, function (data) {
        $panel.toggleClass('text-faded-black');
        $parentForm.toggleClass('d-none');
        $parentSiblingForm.toggleClass('d-none')
    }, "json");
}